import { CODIGOS_ARCHIVO, prefijoDeCodigo } from "@/componentes/identidad/identidad"

/** Un campo de texto con su contador. Uno solo, para que todos se comporten igual. */
export function Texto({
  etiqueta,
  valor,
  max,
  onCambio,
  ayuda,
  opcional = false,
  ancho,
}: {
  etiqueta: string
  valor: string
  max: number
  onCambio: (valor: string) => void
  ayuda?: string
  opcional?: boolean
  ancho?: string
}) {
  // El contador aparece cerca del tope y no siempre: verlo desde el carácter uno
  // convierte cada campo en un examen.
  const cerca = valor.length > max * 0.8

  return (
    <label className={`grid gap-1 ${ancho ?? ""}`}>
      <span className="text-xs font-medium">
        {etiqueta}
        {opcional ? <span style={{ color: "var(--fg-muted)" }}> · opcional</span> : null}
      </span>
      <input
        className="campo h-9 text-sm"
        value={valor}
        maxLength={max}
        onChange={(e) => onCambio(e.target.value)}
      />
      {cerca ? (
        <span className="tabular text-xs" style={{ color: "var(--warning)" }}>
          {valor.length} de {max} · a partir de aquí no cabe en el formato
        </span>
      ) : ayuda ? (
        <span className="text-xs" style={{ color: "var(--fg-muted)" }}>
          {ayuda}
        </span>
      ) : null}
    </label>
  )
}

/**
 * Departamento y código de archivo, juntos: el departamento PROPONE el prefijo del
 * manual («Finanzas» → «FI–») sólo si el código sigue vacío. Ninguno se impone: la tabla
 * del manual trae cuatro departamentos y se puede escribir otro.
 */
export function DepartamentoYCodigo({
  departamento,
  codigo,
  onCambio,
}: {
  departamento: string
  codigo: string
  onCambio: (departamento: string | null, codigo: string | null) => void
}) {
  return (
    <div className="grid grid-cols-[1fr_auto] gap-3">
      <label className="grid gap-1">
        <span className="text-xs font-medium">
          Departamento<span style={{ color: "var(--fg-muted)" }}> · opcional</span>
        </span>
        <input
          className="campo h-9 text-sm"
          list="departamentos-de-archivo"
          value={departamento}
          maxLength={40}
          onChange={(e) => {
            const nuevo = e.target.value
            onCambio(nuevo || null, codigo || prefijoDeCodigo(nuevo) || null)
          }}
        />
        <datalist id="departamentos-de-archivo">
          {CODIGOS_ARCHIVO.map((fila) => (
            <option key={fila.codigo} value={fila.departamento} />
          ))}
        </datalist>
      </label>
      <Texto
        etiqueta="Código"
        valor={codigo}
        max={12}
        opcional={true}
        ancho="w-32"
        ayuda="FI–012"
        onCambio={(v) => onCambio(departamento || null, v.toUpperCase() || null)}
      />
    </div>
  )
}
